import '@linktivity/link-styles';
import App from '@kurotetsu/online/App';
import '@kurotetsu/online/i18n';
import '@kurotetsu/online/styles/index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
